import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import Notifications from './Notifications'
import Chat from './Messages'
import './style.scss'

const chat = <Chat />
const notifications = <Notifications />
const Chats: React.FC = () => {
  const [smallScreen, updateScreen] = useState(window.innerWidth < 700)
  const { id } = useParams<{ id?: string }>()

  useEffect(() => {
    const resize = () => {
      updateScreen(window.innerWidth < 700)
    }
    window.addEventListener('resize', resize)
    return () => {
      window.removeEventListener('resize', resize)
    }
  }, [])

  return (
    <div className='chat'>
      <div className='chat__main'>
        {smallScreen ?
          id
            ? chat
            : notifications
          : (
            <div className='chat__group'>
              <div className='chat__left'>{notifications}</div>
              <div className='chat__right'>{chat}</div>
            </div>
          )}
      </div>
    </div>
  )
}

export default Chats